<template>
	<div ref="sharingOptions" class="flex w-full items-center justify-center gap-x-6 py-2 md2:justify-around md2:mt-2 xl:mt-4 lg:px-28 xl:px-32 2xl:px-32 3xl:px-32">
		<div v-for="method in share" :key="method" class="relative">
			<button @click="method.action" class="flex mx-4">
				<img :src="method.image" alt="Features Icons" class="w-5 h-5 mr-1 m-auto" />
				<span class="m-auto text-start flex w-full justify-start text-ihh-slate-gray text-xs">
					{{ method.title }}
				</span>
			</button>
			<div
				v-if="method.title === 'Share' && showSocials"
				class="absolute right-0 bottom-full mb-2 flex justify-evenly items-center w-52 space-x-1 py-3 shadow-xl rounded-lg bg-ihh-white border z-50"
			>
				<div v-for="s in socials">
					<a :href="s.url" target="_blank">
						<img :src="s.img" :alt="s.name" class="h-4" />
					</a>
				</div>
				<div>
					<button @click="copyLink">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							class="h-4 w-4 text-ihh-slate-gray hover:text-ihh-dark-purple transition-colors"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							stroke-width="2"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
							/>
						</svg>
					</button>
				</div>
			</div>
		</div>
	</div>

	<Teleport to="body">
		<div
			v-if="linkCopied"
			style="
				position: fixed;
				bottom: 24px;
				left: 50%;
				transform: translateX(-50%);
				z-index: 9999;
				background: #2d2d3f;
				color: #fff;
				font-size: 14px;
				padding: 10px 20px;
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
				white-space: nowrap;
			"
		>
			Link copied to clipboard!
		</div>
	</Teleport>
</template>

<script>
export default {
	name: 'ProductSharingOptions',
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			productUrl: '',
			showSocials: false,
			linkCopied: false,
			share: [
				{
					title: 'Email',
					image: 'https://cfl-mango.s3.amazonaws.com/uploads/downloads/ob-envelope.svg',
					action: this.shareToEmail,
				},
				{
					title: 'Print',
					image: '/images/ob-print-0129.svg',
					action: this.shareToPrinter,
				},
				{
					title: 'Share',
					image: '/images/ob-share-0129.svg',
					action: this.toggleSocials,
				},
			],
		}
	},
	mounted() {
		if (this.product?.customUrl?.url) {
			this.productUrl = this.product.customUrl.url
		}
		document.addEventListener('click', this.handleClickOutside)
	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside)
	},
	methods: {
		shareToEmail() {
			const subject = `${this.product.name} - In His Hands Birth Supply`
			const body = `Check out this product: https://www.inhishands.com${this.product.customUrl.url}`
			const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
			window.location.href = mailtoLink
		},
		shareToPrinter() {
			// Print the page
			window.print()
		},
		shareToSocials() {},
		toggleSocials() {
			this.showSocials = !this.showSocials
		},
		async copyLink() {
			const url = `https://www.inhishands.com${this.productUrl}`
			await navigator.clipboard.writeText(url)
			this.showSocials = false
			this.linkCopied = true
			setTimeout(() => {
				this.linkCopied = false
			}, 2500)
		},
		handleClickOutside(e) {
			if (this.showSocials && !this.$refs.sharingOptions.contains(e.target)) {
				this.showSocials = false
			}
		},
	},
	computed: {
		socials() {
			if (!this.productUrl) {
				return [] // Return an empty array until productUrl is set
			}

			return [
				{
					name: 'FB',
					img: '/images/ihh-facebook0129.svg',
					url: `https://www.facebook.com/sharer/sharer.php?u=https://www.inhishands.com${this.productUrl}`,
				},
				{
					name: 'X',
					img: '/images/x.svg',
					url: `https://twitter.com/intent/tweet?url=https://www.inhishands.com${this.productUrl}`,
				},
				{
					name: 'Pinterest',
					img: '/images/ihh-pinterest0129.svg',
					url: `https://pinterest.com/pin/create/button/?url=https://www.inhishands.com${this.productUrl}`,
				},
			]
		},
	},
}
</script>

<style scoped></style>
